import { useState } from "react";
import {
  MAX_FILE_UPLOAD_SIZE_FIGURE,
  MAX_FILE_UPLOAD_SIZE_TEXT,
} from "../utils/constants";
import {
  convertFileToBase64,
  isValidFileType,
  removeMetadataFromFile,
} from "../utils/helpers";
import { errorToast } from "../utils/makeToast";

const useProcessFile = (isBlob: boolean = false) => {
  const [file, setFile] = useState<File | null>(null);
  const processFile = (
    docFile: File,
    callBack?: (str: string, file: File) => void
  ) => {
    if (!docFile) return;
    if (!isValidFileType(docFile)) {
      return errorToast("Invalid file type");
    }
    const fileSizeInKb = docFile.size / 1_000;
    if (fileSizeInKb > MAX_FILE_UPLOAD_SIZE_FIGURE) {
      return errorToast(
        `File size exceeds ${MAX_FILE_UPLOAD_SIZE_TEXT?.toUpperCase()}. Please upload a smaller file.`
      );
    }
    setFile(file);
    if (isBlob) {
      convertFileToBase64(docFile).then(
        (fileUrl) => callBack && callBack(fileUrl, docFile)
      );
    } else
      removeMetadataFromFile(docFile, async (blob) => {
        const imageStr = await convertFileToBase64(blob);
        callBack && callBack(imageStr, docFile);
      });
  };
  return { processFile, file, setFile };
};

export default useProcessFile;
